var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.98963C5.5 4.01847 5.5 3.53289 5.70249 3.26522C5.87889 3.03203 6.14852 2.88773 6.4404 2.8703C6.77544 2.8503 7.17946 3.11965 7.98752 3.65835L18.5031 10.6687C19.1708 11.1139 19.5046 11.3364 19.6209 11.6169C19.7227 11.8622 19.7227 12.1378 19.6209 12.3831C19.5046 12.6636 19.1708 12.8862 18.5031 13.3313L7.98752 20.3417C7.17946 20.8804 6.77544 21.1497 6.4404 21.1297C6.14852 21.1123 5.87889 20.968 5.70249 20.7348C5.5 20.4671 5.5 19.9815 5.5 19.0104V4.98963Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.4596aaca2798afd24ec281b835803b9b.svg";
export { ForwardRef as ReactComponent };